'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http, $filter) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.dateStartOld = new Date($scope.$context.date_start) < new Date();

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;

		const data = {
			user: $scope.selectedUser.uuid,
			date_start: $scope.$context.loc_date_start,
			time_start: $scope.$context.loc_time_start,
			date_end: $scope.$context.loc_date_end,
			time_end: $scope.$context.loc_time_end,
			tzstr: $scope.$context.tz,
		};

		if ($scope.$context.designation) {
			data.designation = $scope.$context.designation.uuid;
		}

		// Our API end point assumes NOW if either date_start or time_start are
		// missing.  In the case of updating the actively scheduled profile, the
		// start date will be older than now.
		if (new Date($scope.$context.date_start) < new Date()) {
			delete data.date_start;
			delete data.time_start;
		}

		switch ($scope.phoneType) {
			case 0:
				data.phone_number = $scope.sharedPhoneNumber;
				break;
			case 1:
				data.phone_number = $scope.selectedUser.phone_number;
				break;
			case 2:
				data.phone_number = $scope.customPhoneNumber;
				break;
		}

		if ($scope.$context.forBulkAssignment) {
			$scope.$close({
				designation: $scope.$context.designation || 'all',
				user: $scope.selectedUser,
				phoneNumber: data.phone_number,
			});
			return;
		}

		$http({
			method: 'POST',
			url: '/api/entities/admin/v2/schedule_designation_profile',
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
